export default __webpack_public_path__ + "static/media/brendan_nelson.a8026866.jpg";